// OfficePayrollAdjustmentHistory.ts
// Event handler for Office Payroll Adjustment History report layout

import { AutogenLayoutOfficePayrollAdjustmentHistory } from "./autogen/AutogenLayoutOfficePayrollAdjustmentHistory";

export class OfficePayrollAdjustmentHistory extends AutogenLayoutOfficePayrollAdjustmentHistory {

    onLoad() {
        // Initialize report with detailed view selected by default
        if (this.switchReportType) {
            this.switchReportType.checked = true; // Detailed report by default (right side)
        }

        // Initialize group by dropdown with "Payee" as default
        if (this.textboxGroupBy) {
            this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0]; // Should be "Payee"
        }

        // Ensure payee type is disabled initially (since include settlement defaults to unchecked)
        if (this.textboxPayeeType) {
            this.textboxPayeeType.enabled = false;
        }
    }

    /**
     * Event handler for Include Settlement checkbox changes
     * Enables/disables the Payee Type field based on checkbox state
     */
    checkboxIncludeSettlementOnChange() {
        this.excludabletextboxPayee.textbox.clear();
        if(this.checkboxIncludeSettlement.checked) {
            this.excludabletextboxPayee.textbox.lookupModel = "lme/settlement/transfer-to-settlement-payee";
            this.excludabletextboxPayee.textbox.lookupModelLayout = "lme/settlement/TransferToSettlementPayeeLookup";
        }
        else {
            this.excludabletextboxPayee.textbox.lookupModel = "lme/settlement/officepayroll/off-payee";
            this.excludabletextboxPayee.textbox.lookupModelLayout = "lme/settlement/officepayroll/OfficePayeeLookup";
        }
        if (this.checkboxIncludeSettlement && this.textboxPayeeType) {
            // Enable Payee Type textbox when Include Settlement is checked
            this.textboxPayeeType.enabled = this.checkboxIncludeSettlement.checked;

            // Clear payee type selection when disabled
            if (!this.checkboxIncludeSettlement.checked) {
                this.textboxPayeeType.text = "";
                this.textboxPayeeType.selectedItem = null;
            }
        }
    }


}
